import script from "./EstimateDocumentViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateDocumentViewer.vue?vue&type=script&setup=true&lang=js"

import "./EstimateDocumentViewer.vue?vue&type=style&index=0&id=71e231b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e231b4"]])

export default __exports__